import { Loader2 } from "lucide-react";

import { Button } from "components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "components/ui/dialog";
import { Textarea } from "components/ui/textarea";

import { MONTHS_PT } from "../constants";
import { type MonthView, getMonthYear } from "../types";

interface ReleaseDialogProps {
  open: boolean;
  target: MonthView | null;
  observation: string;
  isLoading: boolean;
  onObservationChange: (value: string) => void;
  onClose: () => void;
  onConfirm: () => void;
}

export function ReleaseDialog({
  open,
  target,
  observation,
  isLoading,
  onObservationChange,
  onClose,
  onConfirm,
}: ReleaseDialogProps) {
  const label = target
    ? `${MONTHS_PT[getMonthYear(target).month - 1]}/${getMonthYear(target).year}`
    : "";

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Liberar Período Fiscal</DialogTitle>
          <DialogDescription>
            Você está prestes a liberar{" "}
            <span className="font-semibold text-foreground">{label}</span> para
            extração.
          </DialogDescription>
        </DialogHeader>
        <div className="py-2">
          <label className="block text-xs font-bold uppercase text-muted-foreground mb-2">
            Observação (opcional)
          </label>
          <Textarea
            value={observation}
            onChange={(e) => onObservationChange(e.target.value)}
            placeholder="Descreva o motivo da liberação..."
            className="h-24"
          />
        </div>
        <DialogFooter className="gap-2 sm:gap-2">
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            Cancelar
          </Button>
          <Button
            className="bg-green-600 hover:bg-green-700 text-white"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Confirmar Liberação
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
